import React, {useContext, useEffect, useState} from "react";
import style from "./chatUserDetail.module.css";
import {useTranslation} from "react-i18next";
import {DownOutlined, LoadingOutlined, UpOutlined} from "@ant-design/icons";
import {Spin, Tooltip} from "antd";
//@ts-ignore
import {UnmountClosed} from "react-collapse";
import useFetch, {CachePolicies} from "use-http";
import {ChatContext} from "src/pages/context/Chat.context";
import moment from "moment";
import * as GroupAPI from "src/service/group.service";
import Skeleton from "react-loading-skeleton";
import {width} from "./Chat.const";
import {checkMobile} from "src/service/util.service";
import ButtonCenterBack from "src/components/shared/button/BackButton/ButtonCenterBack";
import ButtonCenterCLose from "src/components/shared/button/CloseButton/ButtonCenterClose";

const FRIEND_STATUS_TEXT = {
  CONNECTED: "Connected",
  HAS_REQUESTED: "Accept",
  PENDING: "Requested",
  CONNECT: "Connect",
};

const ChatUserDetail = () => {
  const { t } = useTranslation();
  const chatCtx: any = useContext(ChatContext);
  const [isCollapseGroup, setIsCollapseGroup] = useState(true);
  const [profileImage, setProfileImage]: any = useState("");
  const [birthDate, setBirthDate]: any = useState("");
  const [age, setAge]: any = useState("");
  const [country, setCounty]: any = useState("");
  const [mutualGroups, setMutualGroups] = useState([]);
  const [fullname, setFullname] = useState("");
  const [friendStatus, setFriendStatus]: any = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);

  const mutualGroup = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/detail`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const friendDetail = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/find",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const requestStatus = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/status-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const friends = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/friends",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const acceptFriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/accept-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const addFriend = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/add-friend",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const handleCollapseGroup = () => {
    setIsCollapseGroup(!isCollapseGroup);
  };

  const formatBirthday = (date: string) => {
    if (date !== null) {
      return moment(date).format("DD MMM YYYY");
    } else {
      return "-";
    }
  };

  const calculateAge = (birthday: string) => {
    if (birthday !== null) {
      const a = moment();
      const b = moment(birthday, "YYYY");
      const diff = a.diff(b, "years");
      return diff;
    } else {
      return "-";
    }
  };

  const checkFriendStatus = async () => {   
    try {
      const userSelected = chatCtx.userSelectedId;
      const isFriends = await friends.get(`?mode=add&search=${userSelected}`);

      if (isFriends?.data?.length === 0) {
        const status = await requestStatus.get(`?id=${userSelected}`);

        if (requestStatus.response.ok) {
          if (status?.friendID === userSelected) {
            return FRIEND_STATUS_TEXT.PENDING;
          } else {
            return FRIEND_STATUS_TEXT.HAS_REQUESTED;
          }
        }

        if (status?.code === 500) {
          return FRIEND_STATUS_TEXT.CONNECT;
        }
      } else if (isFriends?.data?.length !== 0) {
        return FRIEND_STATUS_TEXT.CONNECTED;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const connect = async () => {
    try {
      const res = await addFriend.post({ friendID: chatCtx.userSelectedId });
      if (addFriend?.response?.ok) {
        if (res?.type === "request") {
          setFriendStatus(FRIEND_STATUS_TEXT.PENDING);
          chatCtx.setUserDetail({
            mutualGroups: mutualGroups,
            profileImage: profileImage,
            birthDate: birthDate,
            age: age,
            country: country,
            fullname: fullname,
            friendStatus: FRIEND_STATUS_TEXT.PENDING,
          });
        } else if (res?.type === "accept") {
          setFriendStatus(FRIEND_STATUS_TEXT.CONNECTED);
          chatCtx.setUserDetail({
            mutualGroups: mutualGroups,
            profileImage: profileImage,
            birthDate: birthDate,
            age: age,
            country: country,
            fullname: fullname,
            friendStatus: FRIEND_STATUS_TEXT.CONNECTED,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const acceptRequest = async () => {
    try {
      await acceptFriend.post({ friendID: chatCtx.userSelectedId });
      if (acceptFriend.response.ok) {
        setFriendStatus(FRIEND_STATUS_TEXT.CONNECTED);
        chatCtx.setUserDetail({
          mutualGroups: mutualGroups,
          profileImage: profileImage,
          birthDate: birthDate,
          age: age,
          country: country,
          fullname: fullname,
          friendStatus: FRIEND_STATUS_TEXT.CONNECTED,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFriendStatus = async () => {
    setBtnLoading(true);
    if (friendStatus === FRIEND_STATUS_TEXT.CONNECT) {
      await connect();
    } else if (friendStatus === FRIEND_STATUS_TEXT.HAS_REQUESTED) {
      await acceptRequest();
    }
    setBtnLoading(false);
  };

  const getMutualGroups = (myGroups: any, mutualData: any) => {
    if (!mutualData) return;
    const mutualG = mutualData.map((group: any) => {
      return myGroups.find((mygroup: any) => {
        return mygroup.id === group.id;
      });
    });

    return mutualG;
  };

  const getUserDetail = async () => {
    setIsLoading(true);
    if (!chatCtx.sameUserDetail) {
      const userSelected = chatCtx.userSelectedId;
      try {
        const mutual = await mutualGroup.get(`/${userSelected}`);
        const detail = await friendDetail.get(`?id=${userSelected}`);
        const { data } = await GroupAPI.findMyGroup("", -1, 0, null);

        const mutualgroup = getMutualGroups(data.groups, mutual?.mutualGroups);
        const friend_status = await checkFriendStatus();

        setFriendStatus(friend_status);
        setMutualGroups(mutualgroup);
        setProfileImage(detail?.imageProfileURL);
        setBirthDate(formatBirthday(detail?.birthDate));
        setAge(calculateAge(detail?.birthDate));
        setCounty(detail?.nationality);
        setFullname(
          `${detail?.firstname} ${detail?.lastname ? detail?.lastname : ""}`
        );

        chatCtx.setUserDetail({
          mutualGroups: mutualgroup,
          profileImage: detail?.imageProfileURL,
          birthDate: formatBirthday(detail?.birthDate),
          age: calculateAge(detail?.birthDate),
          country: detail?.nationality,
          fullname: `${detail?.firstname} ${
            detail?.lastname ? detail?.lastname : ""
          }`,
          friendStatus: friend_status,
        });
        chatCtx.setSameUserDetail(true);
      } catch (error) {
        console.error(error);
      }
    } else if (chatCtx.sameUserDetail) {
      setMutualGroups(chatCtx.userDetail.mutualGroups);
      setProfileImage(chatCtx.userDetail.profileImage);
      setBirthDate(chatCtx.userDetail.birthDate);
      setAge(chatCtx.userDetail.age);
      setCounty(chatCtx.userDetail.country);
      setFullname(chatCtx.userDetail.fullname);
      setFriendStatus(chatCtx.userDetail.friendStatus);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getUserDetail();
    }

    return () => {
      mounted = false;
      chatCtx.setShowUserDetail(false);
      chatCtx.setSameUserDetail(false);
      mutualGroup.abort();
      friendDetail.abort();
      requestStatus.abort();
      friends.abort();
      acceptFriend.abort();
      addFriend.abort();
    };
  }, []);

  useEffect(() => {
    getUserDetail();
  }, [chatCtx.userSelectedId]);

  return (
    <div
      className={style.chatUserDetail}
      style={{ width: checkMobile() ? "100%" : width }}
    >
      <div
        className={style.backButton}
        style={{ position: "absolute", left: "10px", top: "10px" }}
        onClick={() => {
          chatCtx.setShowUserDetail(false);
        }}
      >
        <ButtonCenterBack />
      </div>

      <div
        className={style.closeButton}
        style={{ position: "absolute", right: "30px", top: "25px" }}
        onClick={() => {
          chatCtx.setShowUserDetail(false);
        }}
      >
        <ButtonCenterCLose />
      </div>
      <div className={style.topBox}>
        {isLoading ? (
          <Skeleton
            count={1}
            style={{ width: "147px", height: "142px", borderRadius: "50%" }}
          />
        ) : (
          <div
            className={style.profileImage}
            style={{ backgroundImage: `url(${profileImage})` }}
          />
        )}
        {isLoading ? (
          <Skeleton
            count={1}
            style={{ width: "150px", height: "20px", marginTop: 18 }}
          />
        ) : (
          <Tooltip placement="top" title={fullname} color="#0f4c82">
            <div className={style.userName}>{fullname}</div>
          </Tooltip>
        )}

        {isLoading ? (
          <Skeleton
            count={1}
            style={{ width: "280px", height: "20px", marginTop: 15 }}
          />
        ) : (
          <Tooltip placement="top" title="New Hampshire, USA" color="#0f4c82">
            <div className={style.lastCheckIn}>
              {t("Last check in")}:New Hampshire, USA
            </div>
          </Tooltip>
        )}
        <button
          type="button"
          className={
            friendStatus === FRIEND_STATUS_TEXT.HAS_REQUESTED ||
            friendStatus === FRIEND_STATUS_TEXT.CONNECT
              ? style.clickableBtn
              : style.unclickableBtn
          }
          style={{ marginTop: 20, marginBottom: 28.3 }}
          disabled={
            friendStatus === FRIEND_STATUS_TEXT.HAS_REQUESTED ||
            friendStatus === FRIEND_STATUS_TEXT.CONNECT
              ? false
              : true
          }
          onClick={handleFriendStatus}
        >
          {isLoading || btnLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: "20px", color: "#0f4c82" }}
                />
              }
            />
          ) : (
            t(friendStatus)
          )}
        </button>
      </div>
      {/* <div className={style.divider} />
      <div className={style.detailBox}>
        <div className={style.detailType}>{t("Gender")}</div>
        {isLoading ? (
          <Skeleton count={1} style={{ width: "40px", height: "20px" }} />
        ) : (
          <div className={style.detail}>{t("Male")}</div>
        )}
      </div>

      <div className={style.divider} />
      <div className={style.detailBox}>
        <div className={style.detailType}>{t("Date of Birth")}</div>
        {isLoading ? (
          <Skeleton count={1} style={{ width: "100px", height: "20px" }} />
        ) : (
          <div className={style.detail}>{birthDate}</div>
        )}
      </div>

      <div className={style.divider} />
      <div className={style.detailBox}>
        <div className={style.detailType}>{t("Age")}</div>
        {isLoading ? (
          <Skeleton count={1} style={{ width: "40px", height: "20px" }} />
        ) : (
          <div className={style.detail}>{age}</div>
        )}
      </div>

      <div className={style.divider} />
      <div className={style.detailBox}>
        <div className={style.detailType}>{t("Country")}</div>
        {isLoading ? (
          <Skeleton count={1} style={{ width: "80px", height: "20px" }} />
        ) : (
          <div className={style.detail}>{country}</div>
        )}
      </div> */}

      <div className={style.divider} />
      <div className={style.detailBox}>
        <div className={style.detailType}>
          {t("Mutual Group")} ({mutualGroups == null ? 0 : mutualGroups?.length })
        </div>
        {isCollapseGroup ? (
          <UpOutlined
            style={{ cursor: "pointer" }}
            onClick={handleCollapseGroup}
          />
        ) : (
          <DownOutlined
            style={{ cursor: "pointer" }}
            onClick={handleCollapseGroup}
          />
        )}
      </div>
      <UnmountClosed
        isOpened={isCollapseGroup}
        theme={{ collapse: style.listCollapse, content: "" }}
      >
        <div>
          {mutualGroups?.map((group: any, idx: number) => {
            return (
              <div className={style.groupBox} key={idx}>
                {isLoading ? (
                  <Skeleton
                    count={1}
                    style={{ width: "77px", height: "74px", borderRadius: 4 }}
                  />
                ) : (
                  <div
                    className={style.groupImage}
                    style={{ backgroundImage: `url(${group?.coverImgURL})` }}
                  />
                )}
                <div className={style.groupDetail}>
                  {isLoading ? (
                    <Skeleton
                      count={1}
                      style={{ width: "150px", height: "20px" }}
                    />
                  ) : (
                    <Tooltip
                      placement="top"
                      title={group?.name}
                      color="#0f4c82"
                    >
                      <div className={style.groupName}>{group?.name}</div>
                    </Tooltip>
                  )}
                  {isLoading ? (
                    <Skeleton
                      count={1}
                      style={{ width: "50px", height: "20px" }}
                    />
                  ) : (
                    <div className={style.groupMember}>
                      {group?.totalMember} members
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </UnmountClosed>
    </div>
  );
};

export default ChatUserDetail;
